/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { TypeListePacs } from '@/enums';

/**
 * Options du filtre de statut des listes de PACS (valeurs de TypeListePacs).
 */
const OPTIONS_STATUT_LISTE_PACS: Array<{
  key: TypeListePacs;
  text: string;
  value: TypeListePacs;
}> = [
  {
    key: TypeListePacs.PacsProjet,
    text: 'Projet',
    value: TypeListePacs.PacsProjet,
  },
  {
    key: TypeListePacs.PacsEnCours,
    text: 'En cours',
    value: TypeListePacs.PacsEnCours,
  },
  {
    key: TypeListePacs.PacsDissous,
    text: 'Dissous',
    value: TypeListePacs.PacsDissous,
  },
  {
    key: TypeListePacs.PacsIrrecevable,
    text: 'Irrecevable',
    value: TypeListePacs.PacsIrrecevable,
  },
];

export default OPTIONS_STATUT_LISTE_PACS;
